import type { components } from "../../../types/voislog_api";

/** 解析通知設定（alert-setting）の項目名。チェック1つが1項目にあたる */
export type AlertKey = keyof components["schemas"]["Mi1AlertSetting"];

export type AlertSection = "low" | "high" | "trend";

/** 未測定の通知を初めて送るまでの日数（reminder_days_first）の選択肢。現行 vManagement と同じ */
export const reminderDays = [3, 7, 14, 28] as const;

/**
 * 区分ごとに出すチェックと、「i」で出す説明（翻訳キー NotificationSetting.info.* の末尾）。
 * hasItemInfo の区分は、チェックごとにも「i」を付ける（翻訳キー NotificationSetting.alertInfo.<項目名>）。
 * こころ指数の契約が無ければ、低値の心の活量値だけを出し、高値と傾向は出さない。
 * 契約の判定は現行 vManagement の isOutputStenScore と同じ
 */
export function alertSections(outputStenScore: boolean): {
  section: AlertSection;
  info: string;
  keys: AlertKey[];
  hasItemInfo?: boolean;
}[] {
  if (!outputStenScore) {
    return [
      {
        section: "low",
        info: "low_mental_activity",
        keys: ["alert_email_mental_activity_low_than_usual"],
      },
    ];
  }
  return [
    {
      section: "low",
      info: "low_mind_index",
      keys: [
        "alert_email_mi1result_low",
        "alert_email_mi1result_very_low",
        "alert_email_mi1result_consecutive_low",
        "alert_email_mi1result_consecutive_very_low",
      ],
    },
    {
      section: "high",
      info: "high",
      keys: [
        "alert_email_mi1result_high",
        "alert_email_mi1result_very_high",
        "alert_email_mi1result_consecutive_high",
        "alert_email_mi1result_consecutive_very_high",
      ],
    },
    {
      section: "trend",
      info: "trend",
      hasItemInfo: true,
      keys: [
        "alert_email_mi1_trend_recent_average_decline",
        "alert_email_mi1_trend_consecutive_decline",
        "alert_email_mi1_trend_two_week_average_decline",
        "alert_email_mi1_trend_frequency_decline",
      ],
    },
  ];
}
